import FlowbiteDatepicker from "@components/Datepicker";
import FormField from "@components/FormField";
import { asDate } from "@utils/date";
import { dateFieldLimits } from "@utils/dateValidationRules";
import { useField } from "formik";
import { forwardRef } from "react";

function FormikDatepicker({ label, error, ...props }, ref) {
  const [field, , helpers] = useField(props.name);

  const fieldName = field.name;
  const { min, max } = dateFieldLimits[fieldName] || {};

  const valueAsDate = field.value ? asDate(field.value) : null;

  const handleChange = (picked) => {
    // Flowbite Datepicker typically gives a Date; be defensive:
    const d = picked instanceof Date ? picked : asDate(picked);
    const normalized = d
      ? new Date(d.getFullYear(), d.getMonth(), d.getDate()) // local midnight
      : null;
    helpers.setValue(normalized);
  };

  return (
    <FormField label={label} id={props.name} errorMsg={error}>
      <FlowbiteDatepicker
        name={field.name}
        value={valueAsDate}
        handleOnChange={handleChange}
        handleOnBlur={() => helpers.setTouched(true)}
        errorMsg={error}
        ref={ref}
        minDate={min}
        maxDate={max}
        data-testid={`${props.name}-datepicker`}
      />
    </FormField>
  );
}

export default forwardRef(FormikDatepicker);
